<template>
  <div>
    <b-container class="home-container text-left">
      <b-row class="mb-3">
        <b-col sm="12" md="8 mb-lg-4">
          <h1 class="mb-lg-4">Az ESG a vállalkozások életében</h1>
        </b-col>
      </b-row>
    </b-container>
    <div class="pb-1 m3-5">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-5 mt-3">
          <b-col cols="12" lg="8">
            <h2 class="font-weight-bold mb-4">Környezeti, társadalmi és vállalatirányítási szempontok</h2>
            <p>
              Az elmúlt években globális szinten is megjelent az igény, hogy a vállalatok tartsák szem előtt a
              természeti és környezeti értékeket, termékük, szolgáltatásuk társadalomra gyakorolt hatásait, továbbá a
              működésük átláthatóságát.
            </p>
            <p>
              Az oldalon az alábbi témákról olvashat:
            </p>
            <ul class="mb-3 custom-color">
              <li>
                <a href="#jelentesteteli">
                  Jelentéstételi és beszámolási követelmények
                </a>
              </li>
              <li>
                <a href="#dnshelv">
                  A DNSH elv és az EU Taxonómia alkalmazása a beruházások értékelésében
                </a>
              </li>
              <li>
                <a href="#uzletielony">
                  Milyen üzleti előnyökkel jár az ESG?
                </a>
              </li>
              <li>
                <a href="#finanszirozas">
                  Milyen támogatott finanszírozás áll rendelkezésre?
                </a>
              </li>
            </ul>
          </b-col>
          <b-col offset="1" cols="2" class="p-0 justify-content-end d-lg-block d-none">
            <img src="../assets/img/ESG_aloldalhoz_grafikak_03.jpg" style="width: 180%" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="pb-5 text-center">
      <b-row class="mb-3 mt-3">
        <b-col cols="12" lg="11">
          <p class="mt-4 pb-0">
            Az ESG jelentéstételhez három pilléren belül vizsgálják a vállalkozások fenntarthatósági mutatóit,
            alapvetően az alább jelzett tényezőkre kiterjedően. Az egyes keretrendszerek bizonyos elemeikben
            eltérhetnek.
          </p>
        </b-col>
      </b-row>
    </b-container>
    <div class="m-3 mb-5">
      <b-container class="mt-3">
        <b-row class="mb-4 mt-5">
          <b-col cols="12" lg="4" class="pb-3">
            <div class="info-box info-box-shadow-1">
              <img class="ellipse" src="../assets/img/ellipses/e.svg" />
              <p class="sub-title" style="margin-top: 25px; margin-bottom: 10px;">Environmental - Környezeti</p>
              <ul class="m-1">
                <li>Zöld minősítés</li>
                <li>Éghajlatváltozás (energiagazdálkodás; környezeti, társadalmi hatásokhoz való alkalmazkodás)</li>
                <li>Szennyezés (légszennyezés, aggodalomra okot adó anyagok, környezeti káresemények)</li>
                <li>Vízfelhasználás</li>
                <li>Biológiai sokféleség – a fajok állapotára gyakorolt hatások</li>
                <li>Hulladékok, körforgásos gazdaság</li>
              </ul>
            </div>
          </b-col>
          <b-col cols="12" lg="4">
            <div class="info-box ">
              <img class="ellipse" src="../assets/img/ellipses/s.svg" />
              <p class="sub-title" style="margin-top: -35px; margin-bottom: 13px;">Social - Társadalmi</p>
              <ul>
                <li>Egyenlő bánásmód, esélyegyenlőség</li>
                <li>Munkakörülmények, életszínvonal, egészségvédelem</li>
                <li>Érintett közösségek jogai</li>
                <li>Külső érintettek</li>
                <li>Családbarát követelmények</li>
                <li>Megváltozott munkaképességű, hátrányos helyzetű és helyi munkavállalók foglalkoztatása</li>
              </ul>
            </div>
          </b-col>
          <b-col cols="12" lg="4">
            <span id="jelentesteteli"></span>
            <div class="info-box info-box-shadow-3">
              <img class="ellipse" src="../assets/img/ellipses/g.svg" />
              <p class="sub-title" style="margin-top: -105px; margin-bottom: 13px;">Governance - Vállalatirányítási</p>
              <ul>
                <li>Irányítási rendszerek</li>
                <li>ESG a vezetésben</li>
                <li>Üzleti etika</li>
                <li>Felelős ellátásilánc-menedzsment</li>
                <li>Munkavállalók képzése és szemléletformálása</li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="wrapper-2 mb-3">
      <h2>Jelentéstételi és beszámolási követelmények</h2>
    </div>
    <b-container class="text-left">
      <b-row class="mb-3 mt-3">
        <b-col cols="12">
          <h2>2023 - Vállalati Fenntarthatósági Jelentéstételről szóló irányelv (CSRD)</h2>
        </b-col>
        <b-col cols="12" lg="11">
          <p class="mt-4 pb-0">
            A Vállalati Fenntarthatósági Jelentéstételről szóló irányelv (CSRD) előírja, hogy a vállalkozásoknak be kell
            számolniuk a vállalkozás tevékenységei által az emberekre és a környezetre gyakorolt hatásokról, és arról,
            hogy a fenntarthatósági kérdések hogyan hatnak a vállalkozásra (kettős lényegesség).
          </p>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="text-left">
      <b-row class="mb-3 mt-3">
        <b-col cols="12" lg="7">
          <h2>2024 - ESG törvény</h2>
        </b-col>
        <b-col cols="12" lg="11">
          <p class="mt-4 pb-0">
            A 2024. január 1-től hatályos 2023. évi CVIII. törvény (ESG törvény)
            <strong>
              célja a fenntarthatóság terén a vállalati, a hatósági és egyéb állami feladatok, jogkörök meghatározása.
            </strong>
          </p>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="text-left">
      <b-row class="mb-3 mt-3">
        <b-col cols="12" lg="11" class="mb-2">
          <h2>Fenntarthatósági jelentés és ESG beszámoló</h2>
        </b-col>
        <b-col cols="12" lg="11">
          <p>
            Az <strong>ESG beszámoló nem azonos a</strong> CSRD rendelet által előírt
            <strong>fenntarthatósági jelentéstételi köztelezettséggel.</strong>
          </p>
          <ul class="mb-4 mt-3">
            <li>
              A <strong>FENNTARTHATÓSÁGI JELENTÉST</strong> az éves beszámoló, azon belül is az üzleti terv részeként
              kell elkészíteni és a beszámoló közzétételére vonatkozó szabályok szerint közzétenni.
            </li>
            <li>
              A <strong>CSRD</strong> alapján elkészítendő jelentés tartalmi követelményeit az EU-s rendeleti szintű
              <strong>ESRS szabványcsomag</strong> szabályozza. Mindezt az ezekkel a tartalmakkal módosított
              <strong>Számviteli törvény</strong> (2000. évi C. törvény) is előírja.
            </li>
            <li>
              Az <strong>ESG</strong> törvény előírja, hogy a vállalkozásoknak évente
              <strong>ESG BESZÁMOLÓT</strong> kell készíteniük az előző üzleti évük fenntarthatósági célú átvilágítási
              kötelezettségeinek teljesítéséről, amelyet <strong>ESG tanúsítóval</strong> kötelesek auditáltatni. Az ESG
              beszámolót a vállalkozás ügyvezető szerve hagyja jóvá.A jóváhagyott és auditált ESG beszámolót a
              vállalkozás az üzleti év végét követő hat hónapon belül küldi meg a Szabályozott Tevékenységek Felügyeleti
              Hatóság részére, valamint ingyenesen és nyilvánosan hozzáférhetővé teszi a honlapján. A vállalkozás az ESG
              beszámolójában feltünteti tevékenységének a fenntarthatósági kérdésekre gyakorolt hatásainak megértéséhez
              szükséges információkat, valamint az annak megértéséhez szükséges információkat, hogy a fenntarthatósági
              és társadalmi kérdések hogyan befolyásolják a vállalkozás fejlődését, teljesítményét és helyzetét,
              valamint a társadalommal való viszonyát.
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <div class="wrapper pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">Mikor kell elkészíteni és közzétenni az ESG beszámolókat?</h2>
            <b-row>
              <b-col cols="12" lg="11">
                <p>
                  Az ESG törvény az egyes vállalkozási kategóriák tekintetében eltérő szabályokat állapít meg az első
                  ESG beszámoló elkészítése és közzététele tekintetében. Az első ESG beszámolót az érintetti körök a
                  következő ütemezés szerint készítik el és teszik közzé:
                </p>
                <ul>
                  <li>
                    <strong>2025-ben: az a tőzsdén jegyzett nagyvállalkozás,</strong> amelynél az üzleti évet megelőző
                    két üzleti évben a mérleg fordulónapján a következő három mutatóérték közül bármelyik kettő
                    meghaladta a következő határértéket:
                    <ul>
                      <li>
                        a mérlegfőösszege a
                        <strong>10 milliárd forintot,</strong>
                      </li>
                      <li>
                        az éves nettó árbevétel a
                        <strong>20 milliárd</strong>
                        forintot,
                      </li>
                      <li>
                        az átlagosan foglalkoztatottak száma az
                        <strong>500</strong>
                        főt
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>2026-ban: az a nagyvállalkozás,</strong> amelynél az üzleti évet megelőző két üzleti évben a
                    mérleg fordulónapján főtevékenysége az ESG törvény 1. mellékletében meghatározott – Gazdasági
                    Tevékenységek Egységes Ágazati Osztályozási Rendszere szerinti – ágazatokba sorolható, és esetében
                    az alábbi mutatóértékek meghaladják a következő határértéket:
                    <ul>
                      <li>az éves nettó árbevétel a 90 milliárd forintot,</li>
                      <li>az átlagosan foglalkoztatottak száma az 500 főt.</li>
                    </ul>
                  </li>
                </ul>
                <p>
                  <strong>Eltérő szabályozás az első ESG beszámoló vonatkozásában:</strong> : Az előző két érintetti kör
                  (tőzsdén jegyzett nagyvállalkozás és nagyvállalkozás) a fenntarthatósági célú átvilágítási
                  kötelezettségekre vonatkozó rendelkezéseket első alkalommal oly módon teljesíti, hogy az ESG
                  platformra ESG beszámolót tölt fel, amelyet követően nem tanúsítás, hanem egy előaudit történik, és
                  sem az ESG beszámoló, sem az előaudit eredménye nem nyilvános, és nem kerül közzétételre.
                </p>
                <p>
                  Önkéntesen ESG beszámolót bármelyik vállalkozás készíthet, de ebben az esetben be kell tartania az ESG
                  törvényben foglalt, ESG beszámolókra vonatkozó előírásokat.
                </p>
                <p>
                  Átmeneti rendelkezések:
                </p>
                <ul>
                  <li>
                    2027. június 30-ig a mikro- vagy kisvállalkozástól ESG adatszolgáltatás nem kérhető, valamint a
                    mikro- vagy kisvállalkozás ESG adatszolgáltatásra sem szerződésben, sem írásbeli nyilatkozatban nem
                    vállalhat kötelezettséget,
                  </li>
                  <li>
                    2027. június 30-ig a középvállalkozás ESG adatszolgáltatásra sem szerződésben, sem írásbeli
                    nyilatkozatban nem vállalhat kötelezettséget,
                  </li>
                  <li>
                    ESG beszámoló és a hozzá kapcsolódó tanúsítvány figyelembevételére a 2027. augusztus 31. napját
                    követően megindított közbeszerzési eljárásokban kerülhet sor, első alkalommal a 2026-ban kezdődő
                    üzleti év fenntarthatósági célú átvilágítási kötelezettségeinek teljesítéséről szóló ESG beszámoló,
                    valamint a hozzá kapcsolódó ESG tanúsítvány vehető figyelembe,
                  </li>
                  <li>
                    ESG beszámoló SZTFH felé történő megküldésének és nyilvánosságra hozatalának moratóriuma 2024-2026
                    közötti üzleti évek ESG beszámolóira vonatkozóan:
                  </li>
                  <li>
                    A 2024-2026 közötti üzleti évekről szóló ESG beszámolókat és azok tanúsítását nem kötelező
                    megküldeni az SZTFH felé,
                  </li>
                  <li>
                    A 2024-2026 közötti üzleti évekről szóló ESG beszámolókat és társadalmi felelősségvállalási
                    stratégiákat nem kötelező ingyenesen és nyilvánosan hozzáférhetővé tenni a vállalkozás honlapján
                  </li>
                </ul>
                <p>
                  Az ESG tv. 1. melléklete alapján a Gazdasági Tevékenységek Egységes Ágazati Osztályozási Rendszere
                  szerinti azon főtevékenységek, amelyek esetén egy nagyvállalat kötelezetté válhat:
                </p>
                <b-card-header class="list-titel" header-tag="header" role="tab">
                  <b-button block v-b-toggle.tevekenysegLista variant="primary" class="text-left">
                    Főtevékenységek listája
                    <span class="when-opened">
                      <ChevronRightIcon :size="30" />
                    </span>
                    <span class="when-closed">
                      <ChevronDownIcon :size="30" />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse id="tevekenysegLista" accordion="esg-accordion" role="tabpanel">
                  <b-card-body>
                    <table class="custom-table">
                      <tbody>
                        <tr>
                          <td>20 Vegyi anyag, termék gyártása</td>
                        </tr>
                        <tr>
                          <td>21 Gyógyszergyártás</td>
                        </tr>
                        <tr>
                          <td>22 Gumi-, műanyag termék gyártása</td>
                        </tr>
                        <tr>
                          <td>23 Nemfém ásványi termék gyártása</td>
                        </tr>
                        <tr>
                          <td>24 Fém alapanyag gyártása</td>
                        </tr>
                        <tr>
                          <td>25 Fémfeldolgozási termék gyártása</td>
                        </tr>
                        <tr>
                          <td>26 Számítógép, elektronikai, optikai termék gyártása</td>
                        </tr>
                        <tr>
                          <td>27 Villamos berendezés gyártása</td>
                        </tr>
                        <tr>
                          <td>28 Gép, gépi berendezés gyártása</td>
                        </tr>
                        <tr>
                          <td>29 Közúti jármű gyártása</td>
                        </tr>
                        <tr>
                          <td>30 Egyéb jármű gyártása</td>
                        </tr>
                        <tr>
                          <td>31 Bútorgyártás</td>
                        </tr>
                        <tr>
                          <td>32 Egyéb feldolgozóipari tevékenység</td>
                        </tr>
                        <tr>
                          <td>33 Ipari gép, berendezés, eszköz javítása, karbantartása, üzembe helyezése</td>
                        </tr>
                        <tr>
                          <td>35 Villamosenergia-, gáz-, gőzellátás, légkondicionálás</td>
                        </tr>
                        <tr>
                          <td>46 Nagykereskedelem</td>
                        </tr>
                        <tr>
                          <td>47 Kiskereskedelem</td>
                        </tr>
                        <tr>
                          <td>49 Szárazföldi, csővezetékes szállítás</td>
                        </tr>
                        <tr>
                          <td>50 Vízi szállítás</td>
                        </tr>
                        <tr>
                          <td>51 Légi szállítás</td>
                        </tr>
                        <tr>
                          <td>61 Távközlés</td>
                        </tr>
                        <tr>
                          <td>62 Információtechnológiai szolgáltatás</td>
                        </tr>
                        <tr>
                          <td>
                            63 Számítástechnikai infrastruktúra, adatfeldolgozás, tárhelyszolgáltatás és egyéb
                            információs szolgáltatási tevékenységek
                          </td>
                        </tr>
                        <tr>
                          <td>64 Pénzügyi szolgáltatás</td>
                        </tr>
                        <tr>
                          <td>65 Biztosítás, viszontbiztosítás, nyugdíjalapok</td>
                        </tr>
                        <tr>
                          <td>66 Pénzügyi, biztosítási kiegészítő tevékenységek</td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card-body>
                </b-collapse>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <span id="dnshelv"></span>
      </b-container>
      <b-container>
        <b-row class="mb-3 ">
          <b-col cols="12" style="margin-left: -2px;">
            <img src="../assets/img/ESG/ESG_tv_bevezetés_MF.png" style="max-width: 100%;" class="desktop-image" />
            <img src="../assets/img/ESG/ESG_tv_bevezetés_MF.png" style="max-width: 100%;" class="mobile-image" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="pt-3 funding">
      <div class="wrapper-2 mb-3">
        <h2>A DNSH elv és az EU Taxonómia alkalmazása a beruházások értékelésében</h2>
      </div>
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="11">
            <p>
              A jelentős károkozás elkerülését célzó elvet (angolul: Do No Significant Harm, azaz DNSH) a taxonómiai
              rendelet néven ismert 2020. június 18-i (EU) 2020/852 európai parlamenti és tanácsi rendelet vezette be.
            </p>
            <table>
              A taxonómiai rendelet 9. cikke az alábbiak szerint határozza meg a 6 környezeti célkitűzést:
              <ul class="mb-4 mt-3">
                <li>az éghajlatváltozás mérséklése;</li>
                <li>az éghajlatváltozáshoz való alkalmazkodás;</li>
                <li>a vízi és tengeri erőforrások fenntartható használata és védelme;</li>
                <li>a körforgásos gazdaságra való átállás;</li>
                <li>a szennyezés megelőzése és csökkentése;</li>
                <li>a biológiai sokféleség és az ökoszisztémák védelme és helyreállítása.</li>
              </ul>
            </table>
            <span id="uzletielony"></span>
            <p>
              A DNSH elv érvényesítése a kohéziós politikában is kötelező, így az ennek keretében megvalósuló operatív
              programok sem támogathatnak olyan fejlesztést, ami a fentebb bemutatott 6 környezeti cél bármelyikének
              jelentős megsértéséhez vezetne, és ezzel jelentős környezeti kárt okozna.
            </p>
            <p class="B">
              Amennyiben vállalkozásának fenntarthatóvá válásához szakértői segítségre van szüksége vagy szeretne többet
              megtudni a DNSH elv alkalmazásáról, térítésmentes fenntarthatósági mentorálás szolgáltatásunkra
              <a href="mailto:esg@mgfu.hu">esg@mgfu.hu</a> e-mail címre küldött kapcsolatfelvétellel tud jelentkezni.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="wrapper-2 mb-3">
      <h2>Milyen üzleti előnyökkel jár az ESG?</h2>
    </div>
    <div class="pt-3 pb-5 funding">
      <b-container class="text-left">
        <p>
          Az ESG jelentés és a transzparencia egyre fontosabbá válik a beszállítói hálózatokban is, az ESG megfelelés
          fontos kiválasztási kritérium lehet. Az ESG beszámoló készítése és tanúsítása számos üzleti előnnyel járhat.
        </p>
        <p>
          <span class="greenP">Jobb hozzáférés a befektetőkhöz és a tőkéhez:</span>
          A befektetők egyre inkább olyan cégekbe fektetnek, amelyek hosszú távú stabilitását fenntarthatósági
          teljesítményük és stratégiájuk is alátámasztja. A tanúsított ESG beszámoló ezért segíthet a fenntarthatóságra
          összpontosító befektetők vonzásában.
        </p>
        <p>
          <span class="greenP">Megkülönböztetés a versenytársaktól</span>
          A versenyelőnyre törekvő vállalkozások ESG területen elért eredményeik és terveik révén is képesek
          megkülönböztetni magukat a versenytársaktól. A fenntarthatóság melletti elkötelezettségük demonstrálása
          vonzóbbá teheti ezeket a céget a fogyasztók, az ügyfelek és a tehetséges álláskeresők számára is. Emellett az
          ESG tanúsítás segíthet a globális piacon is versenyképesebbé válni.
        </p>
        <p>
          <span class="greenP">Nélkülözhetetlenné válik a beszállítói pozíció megszerzésében vagy megőrzésében</span>
          A német ellátási láncok által érintett vállalkozások már tapasztalják, hogy ESG felkészültségüket a
          megrendelőik elvártnak tekintik. Az EU CSRD-ből és a hazai ESG törvényből adódóan ezt már a hazai
          nagyvállalati beszállítók is érzik.
        </p>
        <p>
          <span class="greenP">Kockázatok csökkentése:</span>
          Az ESG folyamat segít a cégeknek azonosítani és kezelni azokat a fenntarthatósággal kapcsolatos kockázatokat,
          így például az éghajlatváltozáshoz kapcsolódó kockázatokat, amelyek sorsdöntők lehetnek a vállalkozás
          fejlődését tekintve.
        </p>
        <p>
          <span class="greenP">Hatékonyság növelése:</span>
          Az ESG felkészülés segíti a cégeket újabb hatékonyságnövelési lehetőségek azonosításában, így például az
          energiafelhasználás és a hulladéktermelés csökkentése terén. Az ESG bevezetése bizonyos iparágakban sokkal
          nagyobb előnnyel járhatnak, például az energiaintenzív vagy anyagintenzív ágazatokban.
        </p>
        <p>
          <span class="greenP">A márka és a hírnév javítása:</span>
          A nyilvánosan elérhető és külső fél által tanúsított ESG beszámoló segíti a márka és hírnév megőrzésében és
          javításában, mert ez által felelősségteljesebb vállalatként tekintenek rájuk az érdekeltek.
        </p>
        <p>
          <span class="greenP">A jogszabályi követelményeknek való megfelelés javulása:</span>
          A fenntarthatósággal kapcsolatos jogszabályok gyorsan változnak és egyre szigorúbbak. Az ESG rendszerén belül
          az ún. compliance terület segítheti a cégek garantált megfelelését ezeknek a követelményeknek.
        </p>
        <p>
          <span class="greenP">Javuló morál az alkalmazottak körében:</span>
          A megfelelő ESG politika segítheti az alkalmazottak moráljának javulását, sőt, vonzóbbá teheti a céget az
          álláskeresők számára.
        </p>
        <p>
          <span class="greenP">Értéket teremteni a társadalom számára:</span>
          Az ESG tanúsítás segíthet a cégeknek értéket teremteni a társadalom számára, és hozzájárulni a fenntartható
          fejlődéshez.
        </p>
      </b-container>
    </div>
    <span id="finanszirozas"></span>
    <div class="wrapper-2 mb-3">
      <h2 class="font-weight-bold mb-4">Milyen támogatott finanszírozás áll rendelkezésre?</h2>
    </div>
    <div class="pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <p>
              Tudja meg gyorsan és egyszerűen a Forrástérkép segítségével, hogy céges és pénzügyi adatai alapján a
              céljaihoz mely támogatott finanszírozási eszközöket tudja igénybe venni, akár fenntarthatósági,
              energiahatékonyság témákban is.
            </p>
          </b-col>
          <b-col cols="12" lg="12">
            <b-button
              variant="primary"
              href="https://www.vali.hu/fund-map"
              target="_blank"
              class="align-items-center justify-content-center"
            >
              Tovább a Forrástérképre
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <ESGButton />
  </div>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import ESGButton from './ESGButton.vue'
export default {
  name: 'ESGVallalkozasok',
  components: {
    ChevronDownIcon,
    ChevronRightIcon,
    ESGButton
  }
}
</script>

<style scoped>
.list-titel {
  background: none;
}
.desktop-image {
  display: block;
}
.mobile-image {
  display: none;
}

/* Media Query: Mobil nézethez (max szélesség 768px) */
@media only screen and (max-width: 768px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

.greenP {
  color: #00903c;
  font-weight: bold;
}
.wrapper {
  /* height: 450px; */
  background: #f2f8fa;
  /* border-radius: 0 100px; */
  /* margin-bottom: 11rem; */
}
.wrapper-2 {
  position: relative;
  height: 172px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrapper-3 {
  background: #f2f8fa;
  border-radius: 0 100px;
}
.btn {
  line-height: 32px;
}
.button {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  width: 100%;
  height: 48px;
  line-height: 32px;
  border-radius: 8px;
}

.img-shadow {
  box-shadow: -38px 35px #d9eee2;
  border-radius: 40px 0px;
}

.info-box {
  height: 400px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  word-wrap: break-word;
}

.B {
  font-weight: bold;
}

.info-box-shadow-1 {
  border-radius: 80px 8px 8px 8px;
}
.info-box-shadow-3 {
  border-radius: 8px 80px 8px 8px;
}

.info-box ul {
  text-align: center;
  /* list-style: inside; */
  list-style-position: inside;
}
.info-box li {
  margin-right: 20%;
}

li::marker {
  content: '•  ';
}

.ellipse {
  position: absolute;
  top: -70px;
  left: 135px;
}
.ellipse-2 {
  position: absolute;
  top: -46px;
}
.sub-title {
  text-align: center;
  font-weight: bold;
  color: #00903c;
}

.funding .list-title {
  margin-bottom: -10px;
}
.funding li {
  margin-left: -25px;
}

.custom-color li {
  color: #00903c;
}

.custom-table {
  width: 90%;
  margin: 0 auto; /* középre */
}
.custom-table td {
  text-align: left;
  vertical-align: middle;
  padding: 5px;
  border: 1px solid black; /* keret */
}

@media (max-width: 992px) {
  .ellipse {
    position: absolute;
    top: -70px;
    left: 37%;
  }

  .wrapper {
    margin-bottom: 2rem;
  }
  .wrapper-2 {
    height: 222px;
  }

  .info-box {
    margin-bottom: 80px;
  }
}
.when-opened svg {
  cursor: pointer;
  margin-top: 0px;
  transition: opacity 1s ease-out;
}
.when-closed svg {
  cursor: pointer;
  margin-top: 0px;
  transition: opacity 1s ease-out;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.collapsed > div > div > .when-opened,
:not(.collapsed) > div > div > .when-closed {
  display: none;
}
</style>
